export const REPORT_STATUS_TEXT_MAP = {
  0: '草稿',
  1: '已提交',
  2: '已审核',
  3: '已驳回'
};

export const REPORT_STATUS_TYPE_MAP = {
  0: 'info',
  1: 'warning',
  2: 'success',
  3: 'danger'
};

export const REPORT_STATUS_OPTIONS = [
  { label: '草稿', value: 0 },
  { label: '已提交', value: 1 },
  { label: '已审核', value: 2 },
  { label: '已驳回', value: 3 }
];
